import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBdO1li-5fK75dKFxPNtJ5fdlg_1Z1v1o4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "fda-crl.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "fda-crl",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "fda-crl.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "915287663930",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:915287663930:web:f3a06cab673f246235dc03",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export default app;
